import React, { useState } from 'react';
import { useTranslation } from 'next-i18next';
import Dialog from '@components/atoms/dialog/dialog';
import sanitizer from '@helpers/sanitizer';
import useWindowSize from '@hooks/use-window-size';
import { CountryTaxInformation } from '@interfaces/models/seller-info/seller-information';
import styles from './tax-info-modal.module.scss';

type TaxInfoModalProps = {
  children: React.ReactNode;
  taxInfo?: CountryTaxInformation;
};

const TaxInfoModal: React.FC<TaxInfoModalProps> = ({ children, taxInfo }): React.JSX.Element => {
  const { t } = useTranslation('get-paid');
  const { isWiderThanMd } = useWindowSize();
  const [openModal, setOpenModal] = useState<boolean>(false);

  return (
    <>
      <button
        tabIndex={0}
        type="button"
        onClick={() => setOpenModal(true)}
      >
        {children}
      </button>
      <Dialog
        key="taxInfoModal"
        isOpen={openModal}
        closeDialog={() => setOpenModal(false)}
        hasCloseIcon
        fullScreenOnMobile={false}
        customClass={styles.taxInfoModal}
        styles={{
          content: {
            width: isWiderThanMd ? '80%' : '90%',
            maxWidth: isWiderThanMd ? '550px' : '460px',
            padding: isWiderThanMd ? '2.5rem' : '1.5rem',
          },
        }}
      >
        {(modalDialogTitleId) => (
          <>
            <h2
              className={styles.taxInfoModal__title}
              data-cy="tax_info_modal_title"
              id={modalDialogTitleId}
            >
              {`${t(`GET_PAID.TAX_INFORMATION_FORM.TAX_NAME.GENERIC`, 'Tax Identification Number')}`}
            </h2>
            <div
              className={styles.taxInfoModal__content}
              data-cy="tax_info_modal_content"
            >
              {taxInfo && (
                <p
                  dangerouslySetInnerHTML={{
                    __html: sanitizer(t(taxInfo?.content)),
                  }}
                />
              )}
              <p
                dangerouslySetInnerHTML={{
                  __html: sanitizer(
                    t(
                      'GET_PAID.TAX_INFORMATION_FORM.GENERIC_INFO',
                      `You can find more information on your country's tax number on this official website.`,
                    ),
                  ),
                }}
              />
            </div>
          </>
        )}
      </Dialog>
    </>
  );
};

export default TaxInfoModal;
